namespace SolovisGateway.Admin.Users {

    export class UserChangePasswordDialog {

        private _saveCallback;
        private _userId;
        private _isAuth0Enabled;
        private _userPasswordEditor;
        private _dialogWindow;

        constructor(options) {
            var self = this;

            var desiredWidth = Math.min($(window).width() * .8, 550);
            var desiredHeight = Math.min($(window).height() * .8, 255);

            var minWidth = 100;
            var minHeight = 100;

            this._saveCallback = options.saveCallback ? options.saveCallback : null;
            this._userId = options.userId ? options.userId : null;
            this._isAuth0Enabled = options.isAuth0Enabled ? options.isAuth0Enabled : false;

            var editorDiv = $("<div>")
                .css("min-height", "75px");

            this._userPasswordEditor = new SolovisGateway.Admin.Users.UserChangePasswordControl({
                controlHost: editorDiv,
                userId: this._userId
            });

            this._userPasswordEditor.setAsCurrentControl();

            var dialogTitle = this._isAuth0Enabled ? "Change Plug-In Password" : "Change Password";

            this._dialogWindow = new Solovis.UI.Dialog({
                container: editorDiv,

                title: dialogTitle,

                modal: true,
                center: true,
                actions: ["Close"],
                autoOpen: true,
                destroyOnClose: true,
                width: desiredWidth,
                minWidth: minWidth,
                minHeight: minHeight,
                height: desiredHeight,
                buttons: [
                    {
                        label: "Save",
                        click: function () {
                            self._save();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._dialogWindow.close();
                        }
                    }
                ]
            });
        }


        public _cancel() {
            this._dialogWindow.close();
        }

        public _save() {
            var self = this;

            if (this._userPasswordEditor.isValid()) {

                var model = this._userPasswordEditor._getUserPasswordModel();
                Solovis.Rpc.invokeAndWait("~/Admin/UserAdmin/SetUserPassword",
                    {
                        model: model
                    },
                    function (response, success) {
                        if (success) {
                            if (response.result.modelIsValid) {
                                var savedUserChangePasswordEditorModel = response.result.modelResult;

                                self._userPasswordEditor._savedUserChangePasswordEditorModel = savedUserChangePasswordEditorModel;

                                self._dialogWindow.close();
                                if (self._saveCallback) {
                                    self._saveCallback(savedUserChangePasswordEditorModel);
                                }

                            }
                            else {
                                self._userPasswordEditor._formBuilder.applyErrors(response.result.errors);
                            }
                        }
                    });
            }
        }

        public static showDialog(options) {
            var dialog = new SolovisGateway.Admin.Users.UserChangePasswordDialog(options);
        }
    }
}
